<template>
  <div>
    <div class="nft-header">
      <div class="d-flex gap3 align-items-center">
        <div class="btn-back" @click="goBack">
          <img src="../../assets/arrow-left.svg" alt="Arrow Left" />
        </div>
        <div class="title ms-3">{{ $t("dashboard.nft.details.title") }}</div>
      </div>
      <div class="btn-edit">
        <img src="../../assets/icon-pencil.svg" alt="Pencil Icon" />
        <span>{{ $t("dashboard.nft.details.edit") }}</span>
      </div>
    </div>
    <div class="d-block d-md-flex justify-content-between">
      <div class="nft-preview">
        <span class="preview">{{ $t("dashboard.nft.details.preview") }}</span>
        <img :src="this.nftObj.image" alt="NFT Image" />
        <span class="id">
          {{ nftID }}
        </span>
      </div>
      <div class="nft-info">
        <h3 class="color-gold">
          {{ nftID }}
        </h3>
        <p>
          {{
            $t("dashboard.nft.details.createdAt", {
              date: this.nftObj.createdAt,
              creator: this.nftObj.creator,
            })
          }}
        </p>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.category") }}</p>
          <p>{{ nftObj.category }}</p>
        </div>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.category") }}</p>
          <p>{{ nftObj.category }}</p>
        </div>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.address") }}</p>
          <p>{{ nftObj.address }}</p>
        </div>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.description") }}</p>
          <p>{{ nftObj.description }}</p>
        </div>
        <div class="d-flex w-100">
          <div class="item w-50">
            <p>{{ $t("dashboard.nft.details.status") }}</p>
            <p :class="nftObj.status == 'For Sale' ? 'for-sale' : 'hold'">
              {{ nftObj.status }}
            </p>
          </div>
          <div class="item w-50">
            <p>{{ $t("dashboard.nft.details.price") }}</p>
            <p>{{ nftObj.price }} ETH</p>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="d-flex w-100">
      <div class="item w-50">
        <p>{{ $t("dashboard.nft.details.other") }}</p>
        <p>{{ nftObj.other.details }}</p>
      </div>
      <div class="item w-50">
        <p>{{ $t("dashboard.nft.details.category") }}</p>
        <p>{{ nftObj.other.category }}</p>
      </div>
    </div>
    <div class="item">
      <p>{{ $t("dashboard.nft.details.address") }}</p>
      <p>{{ nftObj.other.address }}</p>
    </div>
    <div class="item">
      <p>{{ $t("dashboard.nft.details.description") }}</p>
      <p>{{ nftObj.other.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nftID: String,
  },
  data() {
    return {
      nftObj: {
        id: null,
        name: "",
        image: "",
        createdAt: "",
        creator: "",
        category: "",
        address: "",
        description: "",
        status: "",
        price: 0,
        other: {
          details: "",
          category: "",
          address: "",
          description: "",
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.nftID) {
        this.goBack();
      }
      // 调用API获取NFT信息
      this.nftObj = {
        id: this.nftID,
        name: this.nftID,
        image: "/images/nft/GSG-00032.png",
        createdAt: "16-08-2024 03:33",
        creator: "me",
        category: "GSG Token",
        address: "0x485809bx3e6082Ac554088C94",
        description: "Description of Token here",
        status: "For Sale",
        price: 5.5,
        other: {
          details: "Detail 1",
          category: "GSG Token",
          address: "0x485809bx3e6082Ac554088C94",
          description: "Description of Token here",
        },
      };
    },
    goBack() {
      this.$emit("goBack");
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getData();
    },
  },
};
</script>

<style scoped>
.btn-back {
  border: 1px solid #e1e8ed;
  border-radius: 10px;
  width: 56px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #687b8e;
}
.btn-edit {
  color: #687b8e;
  font-size: 0.85rem;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 0.5rem;
  }
}
.nft-preview {
  position: relative;
  border: 1px solid #e1e8ed;
  border-radius: 1.25rem;
  box-sizing: border-box;
  padding: 3rem 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .preview {
    position: absolute;
    top: 1rem;
    left: 1rem;
  }
  img {
    width: 90%;
  }
  .id {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
  }
}
.nft-info {
  width: 100%;
  padding: 0;
  margin-top: 2rem;
  box-sizing: border-box;
}
.item {
  margin-top: 1rem;
  p {
    margin-bottom: 0.3rem;
  }
  p:first-of-type {
    font-weight: 700;
  }
}

.for-sale,
.hold {
  background-color: #3ab74e;
  padding: 0.3rem 1rem;
  color: white;
  font-size: 0.8rem;
  border-radius: 0.8rem;
  display: block;
  text-align: center;
  width: fit-content;
}
.for-sale {
  background-color: #3ab74e;
}
.hold {
  background-color: #ffb803;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .nft-preview {
    width: 40%;
  }
  .nft-info {
    width: 60%;
    padding: 2rem;
    margin: 0;
  }
}
</style>
